<template>
  <v-card>
    <v-card-title> Insurance </v-card-title>
    <v-card-text>
      <p v-if="!testator.insurance">
        The testator has not started the insurance step yet
      </p>

      <div v-else>
        <div v-if="testator.insurance.estateAdminExpensesCoverRequired">
          <h3 class="mb-2">Cover required</h3>
          <p>
            Cover required for estate administration expenses: R
            {{ testator.insurance.estateAdminExpensesCoverRequired | currency }}
          </p>
          <p>
            Cover required for nominated beneficiary: R
            {{
              testator.insurance.nominatedBeneficiaryCoverRequired | currency
            }}
          </p>
          <p>Nominated beneficiary: {{ nominatedBeneficiary }}</p>
        </div>

        <div v-if="testator.insurance.monthlyIncome">
          <h3 class="mb-2">Questions</h3>
          <p>
            Basic income per month: R
            {{ testator.insurance.monthlyIncome | currency }}
          </p>
          <p>Education level: {{ educationLevel }}</p>
          <p>Smoker: {{ smoker }}</p>
          <p>Replacement policy: {{ replacementPolicy }}</p>
        </div>

        <div v-if="testator.insurance.monthlyPremiumQuoted">
          <h3 class="mb-2">Quotes</h3>
          <p>Subscription type: {{ subscriptionType }}</p>
          <p v-if="premiumQuoted">
            Premium quoted: R {{ premiumQuoted | currency }}
          </p>
        </div>

        <h3 class="mb-2">Policy</h3>
        <div v-if="testator.insurance.rootPolicyNumber">
          <p>Policy number: {{ testator.insurance.rootPolicyNumber }}</p>
          <p>
            Sum assured: R
            {{ (testator.insurance.rootSumAssured / 100) | currency }}
          </p>
        </div>
        <p v-else-if="testator.insurance.skipInsurance">
          Testator opted to skip the insurance step
        </p>
        <p v-else>Testator has not taken out a policy yet</p>

        <h3 v-if="shouldShowSaleProcessId" class="mb-2">DifferentLife</h3>
        <p v-if="shouldShowSaleProcessId">
          Sale process ID: {{ salesProcessId }}
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import { formatKinship } from '../../../constants/js/people';

  export default {
    name: 'InsuranceCard',
    props: {
      testator: {
        required: true,
        type: Object,
      },
      relations: {
        required: true,
        type: Object,
      },
    },
    computed: {
      nominatedBeneficiary() {
        if (this.relations.insuranceNominatedBeneficiary.id) {
          return (
            this.relations.insuranceNominatedBeneficiary.fullName +
            ' - ' +
            formatKinship(
              this.relations.insuranceNominatedBeneficiary.kinship,
              this.testator
            )
          );
        } else {
          return 'Not selected';
        }
      },
      isAdvisor() {
        return this.$store.getters.isAdvisor;
      },
      isTestator() {
        return this.$store.getters.isTestator;
      },
      replacementPolicy() {
        return this.testator.insurance.replacementPolicy ? 'Yes' : 'No';
      },
      salesProcessId() {
        if (
          this.testator.insurance.differentTechLead &&
          this.testator.insurance.differentTechLead.spId
        ) {
          return this.testator.insurance.differentTechLead.spId;
        }
      },
      shouldShowSaleProcessId() {
        if (this.isAdvisor || this.isTestator) {
          return false;
        }

        return true;
      },
      educationLevel() {
        switch (this.testator.insurance.educationLevel) {
          case 'NO_MATRIC':
            return 'No matric';
          case 'MATRIC':
            return 'Matric';
          case 'THREE_YEAR_DEGREE':
            return '3 year degree/diploma';
          case 'FOUR_YEAR_DEGREE':
            return '4 year degree';
          case 'PROFESSIONAL':
            return 'Professional';
          default:
            return 'Not selected';
        }
      },
      smoker() {
        switch (this.testator.insurance.smoker) {
          case true:
            return 'Yes';
          case false:
            return 'No';
          default:
            return 'Not selected';
        }
      },
      subscriptionType() {
        switch (this.testator.insurance.subscriptionType) {
          case 'MONTHLY':
            return 'Monthly';
          case 'ANNUALLY':
            return 'Annually';
          default:
            return 'Not selected';
        }
      },
      premiumQuoted() {
        if (this.testator.insurance.subscriptionType == 'MONTHLY') {
          return this.testator.insurance.monthlyPremiumQuoted;
        } else if (this.testator.insurance.subscriptionType == 'ANNUALLY') {
          return this.testator.insurance.yearlyPremiumQuoted;
        } else {
          return null;
        }
      },
    },
  };
</script>
